import { GetSearchQuery } from '@diritto/common/api/SearchApi';
import { CONTENT_LIST_PAGE_ITEM_COUNT } from '@diritto/common/content/constants';
import { ContentSearchRelayResponseDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { useInfiniteQuery } from '@tanstack/react-query';
import { SearchApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';

const getNextPageParam = (lastGroup: ContentSearchRelayResponseDto, allGroups: ContentSearchRelayResponseDto[]) => {
  if ((lastGroup.contentIds?.length ?? 0) < CONTENT_LIST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + (current.contentIds?.length ?? 0), 0);
};

export const useGetRelaySearchResultsInfiniteQuery = (keyword: string, query: GetSearchQuery) =>
  useInfiniteQuery({
    queryKey: relayQueryKey.searchList(keyword, query),
    queryFn: ({ pageParam = 0 }) =>
      SearchApi.searchRelayContents(keyword, { offset: pageParam, limit: CONTENT_LIST_PAGE_ITEM_COUNT, ...query }),
    initialPageParam: 0,
    getNextPageParam,
  });
